import axiosInstance from "./axiosInstance";

export const getTrayHistory = async (customerId, from = null, to = null) => {
  try {
    const response = await axiosInstance.get(
      `/transactions/tray-history/${customerId}`,
      {
        params: {
          ...(from && { from }),
          ...(to && { to }),
        },
      }
    );
    return response?.data?.result;
  } catch (error) {
    return error?.data?.response?.message;
  }
};

export const getCustomerDetails = async (customerId) => {
  try {
    const response = await axiosInstance.post("/customers/details", {
      customerId,
    });
    return response?.data?.result;
  } catch (error) {
    return error?.data?.response?.message;
  }
};

export const getTrays = async () => {
  try {
    const response = await axiosInstance.get("/trays");
    return response?.data?.list || [];
  } catch (error) {
    return [];
  }
};
